import React from 'react';
import MetricaBase from './MetricaBase';

const MetricaRegioes = () => {
  return (
    <MetricaBase
      titulo="Distribuição por Região"
      descricao="Análise da distribuição de colaboradores ativos por estado"
      endpoint="regioes"
      tipoDownload="regioes"
      cor="blue"
    />
  );
};

export default MetricaRegioes;